export default __webpack_public_path__ + "static/media/msg.ed357a54.png";